/* eslint-disable import/first */
import AboutYouSIO from "@pages/SIO/AboutYou";
import BasicDetailsSIO from "@pages/SIO/BasicDetails";
import ContactSIO from "@pages/SIO/Contact";
import CoverageSIO from "@pages/SIO/Coverage";
import DeclarationSIO from "@pages/SIO/Declaration";
import MyInfoSIO from "@pages/SIO/MyInfo";
import PaymentSIO from "@pages/SIO/Payment";
import ReviewSIO from "@pages/SIO/Review";
import ThankYouSIO from "@pages/SIO/ThankYou";
import SIO from "@pages/SIO";

import BasicDetailsDPI from "@pages/DPI/BasicDetails";
import AboutYouDPI from "@pages/DPI/AboutYou";
import ContactDPI from "@pages/DPI/Contact";
import CoverageDPI from "@pages/DPI/Coverage";
import DeclarationDPI from "@pages/DPI/Declaration";
import MyInfoDPI from "@pages/DPI/MyInfo";
import PaymentDPI from "@pages/DPI/Payment";
import ReviewDPI from "@pages/DPI/Review";
import ThankYouDPI from "@pages/DPI/ThankYou";
import DPI from "@pages/DPI";

import LetsGetStartedMLTC from "@pages/MTLC/LetsGetStarted";
import BasicDetailsMLTC from "@pages/MTLC/BasicDetails";
import ChoosePlanMLTC from "@pages/MTLC/ChoosePlan";
import MyInfoMLTC from "@pages/MTLC/MyInfo";
import HealthMLTC from "@pages/MTLC/Health";
import DeclarationMLTC from "@pages/MTLC/Declaration";
import PaymentMLTC from "@pages/MTLC/Payment";
import ReviewMLTC from "@pages/MTLC/Review";
import ThankYouMLTC from "@pages/MTLC/ThankYou";
import ContactMLTC from "@pages/MTLC/Contact";
import MLTC from "@pages/MTLC";
import BasicDetailsMLTCR3 from "@pages/MLTC_R3/BasicDetails";

//R3 Revamp
import MLTC_REVAMP from "@pages/MLTC_R3";
import ChoosePlanMLTCR3, { ChoosePlanMLTC4 } from "@pages/MLTC_R3/ChoosePlan";
import { HealthDeclarationMLTCR3 } from "@pages/MLTC_R3/HealthDeclaration";
import MyInfo from "@pages/MLTC_R3/MyInfo";
import ReviewMLTCR3 from "@pages/MLTC_R3/Review";
import PaymentMLTC3 from "@pages/MLTC_R3/Payment";
import AgencyMLTCR3 from "@pages/MLTC_R3/Agency";
import ThankYouMLTC3 from "@pages/MLTC_R3/ThankYou";
import ContactForm from "@pages/MLTC_R3/ContactForm";
import PaymentCheckingMLTC3 from "@pages/MLTC_R3/PaymentChecking";
import Declaration from "@pages/MLTC_R3/Declaration";
import Eligibility from "@pages/MLTC_R3/Eligibility";
import SomethingWrong from "@pages/MLTC_R3/SomethingWrong";

//Shield Starter Routes
import { ROUTE_PATH } from "@static/route-paths";
import MailingAddress from "@pages/ShieldStarter/Steps/StartApplication/MailingAddress";
import SingpassPermission from "@pages/ShieldStarter/Steps/StartApplication/SingpassPermission";
import ViewQuotation from "@pages/ShieldStarter/Steps/ChoosePlan/ViewQuotation";
import GetQuote from "@pages/ShieldStarter/Steps/GetQuote";
import ChoosePlan from "@pages/ShieldStarter/Steps/ChoosePlan";
import StartApplication from "@pages/ShieldStarter/Steps/StartApplication";
import PersonalInfo from "@pages/ShieldStarter/Steps/StartApplication/PersonalInfo";
import ShieldContactForm from "@pages/ShieldStarter/Components/ContactForm";
import DeclarationShieldStarter from "@pages/ShieldStarter/Steps/HealthDeclaration/Declaration";
import Adviser from "@pages/ShieldStarter/Steps/HealthDeclaration/Adviser";
import HealthDeclaration from "@pages/ShieldStarter/Steps/HealthDeclaration";
import Review from "@pages/ShieldStarter/Steps/Review/Review";
import Confirmation from "@pages/ShieldStarter/Steps/Confirmation";
import RedirectToGetQuote from "@pages/ShieldStarter/Components/RedirectToGetQuote";
import GenericErrorShieldStarter from "@pages/ShieldStarter/Components/GenericErrorShieldStarter";
import ShieldStarterConnectionError from "@pages/ShieldStarter/Components/ConnectionError";

//Secure Saver Routes
import EverGreenOccupation from "@pages/EverGreen/Steps/Declaration/Occupation";
import EverGreenSingpass from "@pages/EverGreen/Steps/StartApplication/Singpass";
import EverGreenMyInfo from "@pages/EverGreen/Steps/StartApplication/Myinfo";
import EverGreenmailingAddress from "@pages/EverGreen/Steps/StartApplication/MailingAddress";
import EverGreenFinancialAdviser from "@pages/EverGreen/Steps/Declaration/FinancialAdviser";
import EverGreenPEP from "@pages/EverGreen/Steps/Declaration/PEP";
import EverGreenGetStarted from "@pages/EverGreen/Steps/Quote/landingPage";
import EverGreenTax from "@pages/EverGreen/Steps/Declaration/Tax";
import EverGreenQuote from "@pages/EverGreen/Steps/Quote/quotation";
import EverGreenContact from "@pages/EverGreen/Steps/ContactForm";
import EverGreenPayment from "@pages/EverGreen/Steps/ReviewPayment/Payment";
import EverGreenDocumentReview from "@pages/EverGreen/Steps/Declaration/DocumentReview";
import EverGreenReview from "@pages/EverGreen/Steps/ReviewPayment/Review";
import EverGreenThankyou from "@pages/EverGreen/Steps/ThankyouForm";
import EverGreenPaynow from "@pages/EverGreen/Steps/ReviewPayment/Payment/pay-now";
import React, { Component } from "react";

import EverGreenViewQuote from "@pages/EverGreen/Steps/Quote/viewQuotation";
import EverGreenArc from "@pages/EverGreen/Steps/ArcForm/ArcForm";

const EverGreenFastPayment = React.lazy(
  () => import("@pages/EverGreen/Steps/ReviewPayment/Payment/fast-payment")
);

// Cancer Cover
import Calendar from "@components/_Revamp/Calendar";
import DatePicker from "@components/_Revamp/DatePicker";
import { ReactLazyPreload } from "@utils/helpers";

export const CancerCoverBasicInfo = ReactLazyPreload(
  () => import("@pages/CCP/steps/PersonalInfo/BasicInfo")
);
import CancerCoverLanding from "@pages/CCP/steps/PersonalInfo/LandingPage";
import CancerCoverQuotationSummary from "@pages/CCP/steps/PersonalInfo/QuotationSummary";
import CancerCoverUnderWriting2 from "@pages/CCP/steps/HealthDeclaration/UW2";
import CancerCoverUnderWriting3 from "@pages/CCP/steps/HealthDeclaration/UW3";
import CancerCoverUnderWriting1A from "@pages/CCP/steps/HealthDeclaration/UW1/uw1a";
import CancerCoverUnderWriting1B from "@pages/CCP/steps/HealthDeclaration/UW1/uw1b";
import CancerCoverSingpass from "@pages/CCP/steps/ApplicationDetails/Singpass";
import { ContactForm as CancerCoverContactUs } from "@pages/CCP/steps/ContactForm";
import CancerCoverDeclaration from "@pages/CCP/steps/ApplicationDetails/Declaration";
import CancerCoverFAR from "@pages/CCP/steps/ApplicationDetails/FinancialAdviser";
import CancerCoverMyInfo from "@pages/CCP/steps/ApplicationDetails/MyInfo";
import CancerCoverUserDeclaration from "@pages/CCP/steps/Declaration/UserDeclaration";
import CancerCoverPayment from "@pages/CCP/steps/Payment/Payment";
import CancerCoverMailingAddress from "@pages/CCP/steps/ApplicationDetails/MailingAddress";
import CancerCoverReview from "@pages/CCP/steps/Payment/Review";
import CancerCoverPaymentSuccess from "@pages/CCP/steps/Payment/Success";
import { SHIELD_STARTER_ROUTE } from "@static/staticConstents";

export const routes = [
  {
    path: "/dpi",
    name: "DPI",
    component: DPI,
  },
  {
    path: "/sio",
    component: SIO,
    name: "SIO",
  },
  {
    path: "/mltc-r2",
    component: MLTC,
    name: "MLTC",
  },
  {
    path: "/mltc",
    component: MLTC_REVAMP,
    name: "MLTC_REVAMP",
  },
];

export const mltcR3Routes = [
  {
    path: "/mltc/lets-get-started",
    component: BasicDetailsMLTCR3,
  },
  {
    path: "/mltc/choose-plan",
    component: ChoosePlanMLTCR3,
  },
  {
    path: "/mltc/customise-plan",
    component: ChoosePlanMLTC4,
  },
  {
    path: "/mltc/health",
    component: HealthDeclarationMLTCR3,
  },
  {
    path: "/mltc/check-eligibility",
    component: Eligibility,
  },
  {
    path: "/mltc/my-info",
    component: MyInfo,
  },
  {
    path: "/mltc/declaration",
    component: Declaration,
  },
  {
    path: "/mltc/review",
    component: ReviewMLTCR3,
  },
  {
    path: "/mltc/prepayment",
    component: PaymentMLTC3,
  },
  {
    path: "/mltc/advisor",
    component: AgencyMLTCR3,
  },
  {
    path: "/mltc/payment",
    component: PaymentCheckingMLTC3,
  },
  {
    path: "/mltc/thank-you",
    component: ThankYouMLTC3,
  },
  {
    path: "/mltc/contact-form",
    component: ContactForm,
  },
  {
    path: "/mltc/something-wrong",
    component: SomethingWrong,
  },
];
export const mltcRoutes = [
  {
    path: "/mltc-r2/lets-get-started",
    component: LetsGetStartedMLTC,
  },
  {
    path: "/mltc-r2/basic-details",
    component: BasicDetailsMLTC,
  },
  {
    path: "/mltc-r2/choose-plan",
    component: ChoosePlanMLTC,
  },
  {
    path: "/mltc-r2/my-info",
    component: MyInfoMLTC,
  },
  {
    path: "/mltc-r2/health",
    component: HealthMLTC,
  },
  {
    path: "/mltc-r2/declaration",
    component: DeclarationMLTC,
  },
  {
    path: "/mltc-r2/review",
    component: ReviewMLTC,
  },
  {
    path: "/mltc-r2/payment",
    component: PaymentMLTC,
  },
  {
    path: "/mltc-r2/thank-you",
    component: ThankYouMLTC,
  },
  {
    path: "/mltc-r2/contact",
    component: ContactMLTC,
  },
];

export const sioRoutes = [
  {
    path: "/sio/basic-details",
    component: BasicDetailsSIO,
  },
  {
    path: "/sio/about-you",
    component: AboutYouSIO,
  },
  {
    path: "/sio/contact",
    component: ContactSIO,
  },
  {
    path: "/sio/coverage",
    component: CoverageSIO,
  },
  {
    path: "/sio/declaration",
    component: DeclarationSIO,
  },
  {
    path: "/sio/my-info",
    component: MyInfoSIO,
  },
  {
    path: "/sio/payment",
    component: PaymentSIO,
  },
  {
    path: "/sio/review",
    component: ReviewSIO,
  },
  {
    path: "/sio/thank-you",
    component: ThankYouSIO,
  },
];

export const dpiRoutes = [
  {
    path: "/dpi/basic-details",
    component: BasicDetailsDPI,
  },
  {
    path: "/dpi/about-you",
    component: AboutYouDPI,
  },
  {
    path: "/dpi/contact",
    component: ContactDPI,
  },
  {
    path: "/dpi/coverage",
    component: CoverageDPI,
  },
  {
    path: "/dpi/declaration",
    component: DeclarationDPI,
  },
  {
    path: "/dpi/my-info",
    component: MyInfoDPI,
  },
  {
    path: "/dpi/payment",
    component: PaymentDPI,
  },
  {
    path: "/dpi/review",
    component: ReviewDPI,
  },
  {
    path: "/dpi/thank-you",
    component: ThankYouDPI,
  },
];

export const ShieldStarter = [
  {
    path: ROUTE_PATH.SHIELD_STARTER_GET_QUOTE,
    component: () => {
      window.location.replace(SHIELD_STARTER_ROUTE);
      return null;
    },
  },
  {
    path: ROUTE_PATH.SHIELD_STARTER_VIEW_QUOTATION,
    component: ViewQuotation,
  },
  {
    path: ROUTE_PATH.SHIELD_STARTER_CHOOSE_PLAN,
    component: ChoosePlan,
  },
  {
    path: ROUTE_PATH.SHIELD_STARTER_SINGPASS_PERSMISSION,
    component: SingpassPermission,
  },
  {
    path: ROUTE_PATH.SHIELD_STARTER_MAILING_ADDRESS,
    component: MailingAddress,
  },
  {
    path: ROUTE_PATH.SHIELD_STARTER_START_APPLICATION,
    component: StartApplication,
  },
  {
    path: ROUTE_PATH.SHIELD_STARTER_MY_INFO,
    component: PersonalInfo,
  },
  {
    path: ROUTE_PATH.SHIELD_STARTER_CONTACT_US,
    component: ShieldContactForm,
  },
  {
    path: ROUTE_PATH.SHIELD_STARTER_DECLARATION,
    component: DeclarationShieldStarter,
  },
  {
    path: ROUTE_PATH.SHIELD_STARTER_ADVISER,
    component: Adviser,
  },
  {
    path: ROUTE_PATH.SHIELD_STARTER_HEALTH_DECLARATION,
    component: HealthDeclaration,
  },
  {
    path: ROUTE_PATH.SHIELD_STARTER_REVIEW,
    component: Review,
  },
  {
    path: ROUTE_PATH.SHIELD_STARTER_COFIRMATION,
    component: Confirmation,
  },
  {
    path: ROUTE_PATH.SHIELD_STARTER_CONNECTION_ERROR,
    component: ShieldStarterConnectionError,
  },
  {
    path: ROUTE_PATH.SHIELD_STARTER_PAYMENT,
    component: Confirmation,
  },
  {
    path: ROUTE_PATH.SHIELD_STARTER_GENERIC_ERROR,
    component: () => {
      window.location.replace(SHIELD_STARTER_ROUTE);
      return null;
    },
  },
];

export const EverGreen = [
  {
    path: ROUTE_PATH.EVER_GREEN_MY_INFO,
    component: EverGreenMyInfo,
  },
  // {
  //   path: ROUTE_PATH.EVER_GREEN_CONTACTUS,
  //   component: EverGreenMyInfo,
  // },
  {
    path: ROUTE_PATH.EVER_GREEN_OCCUPATION,
    component: EverGreenOccupation,
  },
  {
    path: ROUTE_PATH.EVER_GREEN_SINGPASS,
    component: EverGreenSingpass,
  },
  {
    path: ROUTE_PATH.EVER_GREEN_MAILING_ADDRESS,
    component: EverGreenmailingAddress,
  },
  {
    path: ROUTE_PATH.EVER_GREEN_FINANCIAL_ADVISER,
    component: EverGreenFinancialAdviser,
  },
  {
    path: ROUTE_PATH.EVER_GREEN_PEP,
    component: EverGreenPEP,
  },
  {
    path: ROUTE_PATH.EVER_GREEN_GET_STARTED,
    component: EverGreenGetStarted,
  },
  {
    path: ROUTE_PATH.EVER_GREEN_TAX_DECLARATION,
    component: EverGreenTax,
  },
  {
    path: ROUTE_PATH.EVER_GREEN_QUOTATION,
    component: EverGreenQuote,
  },
  {
    path: ROUTE_PATH.EVER_GREEN_CONTACTUS,
    component: EverGreenContact,
  },
  {
    path: ROUTE_PATH.EVER_GREEN_PAYMENT,
    component: EverGreenPayment,
  },
  {
    path: ROUTE_PATH.EVER_GREEN_DOCUMENT_REVIEW,
    component: EverGreenDocumentReview,
  },
  {
    path: ROUTE_PATH.EVER_GREEN_REVIEW,
    component: EverGreenReview,
  },
  {
    path: ROUTE_PATH.EVER_GREEN_THANK_YOU,
    component: EverGreenThankyou,
  },
  {
    path: ROUTE_PATH.EVER_GREEN_VIEW_QUOTE,
    component: EverGreenViewQuote,
  },
  {
    path: ROUTE_PATH.EVER_GREEN_FAST_PAYMENT,
    component: EverGreenFastPayment,
  },
  {
    path: ROUTE_PATH.EVER_GREEN_ARC,
    component: EverGreenArc,
  },
  {
    path: ROUTE_PATH.EVER_GREEN_PAY_NOW,
    component: EverGreenPaynow,
  },
  {
    path: "/calendar",
    component: DatePicker,
  },
  {
    path: "/calendar",
    component: DatePicker,
  },
];

export const CancerCover = [
  {
    path: ROUTE_PATH.CANCER_COVER_BASIC_INFO,
    component: CancerCoverBasicInfo,
  },
  {
    path: ROUTE_PATH.CANCER_COVER_LANDING_PAGE,
    component: CancerCoverLanding,
  },
  {
    path: ROUTE_PATH.CANCER_COVER_QUOTATION_SUMMARY,
    component: CancerCoverQuotationSummary,
  },
  {
    path: ROUTE_PATH.CANCER_COVER_UW_2,
    component: CancerCoverUnderWriting2,
  },
  {
    path: ROUTE_PATH.CANCER_COVER_UW_3,
    component: CancerCoverUnderWriting3,
  },
  {
    path: ROUTE_PATH.CANCER_COVER_UW_1A,
    component: CancerCoverUnderWriting1A,
  },
  {
    path: ROUTE_PATH.CANCER_COVER_UW_1B,
    component: CancerCoverUnderWriting1B,
  },
  {
    path: ROUTE_PATH.CANCER_COVER_CONTACT_US,
    component: CancerCoverContactUs,
  },
  {
    path: ROUTE_PATH.CANCER_COVER_SINGPASS,
    component: CancerCoverSingpass,
  },
  {
    path: ROUTE_PATH.CANCER_COVER_DECLARATION,
    component: CancerCoverDeclaration,
  },
  {
    path: ROUTE_PATH.CANCER_COVER_FINANCIAL_ADVISER,
    component: CancerCoverFAR,
  },
  {
    path: ROUTE_PATH.CANCER_COVER_MY_INFO,
    component: CancerCoverMyInfo,
  },
  {
    path: ROUTE_PATH.CANCER_COVER_USER_DECLARATION,
    component: CancerCoverUserDeclaration,
  },
  {
    path: ROUTE_PATH.CANCER_COVER_PAYMENT,
    component: CancerCoverPayment,
  },
  {
    path: ROUTE_PATH.CANCER_COVER_MAILING_ADDRESS,
    component: CancerCoverMailingAddress,
  },
  {
    path: ROUTE_PATH.CANCER_COVER_REVIEW,
    component: CancerCoverReview,
  },
  {
    path: ROUTE_PATH.CANCER_COVER_PAYMENT_SUCCESS,
    component: CancerCoverPaymentSuccess,
  },
];
